import axios from 'axios';
import $ from "jquery";
import general from "./general";

const _axios = axios.create({withCredentials: true, paramsSerializer: $.param});

const BASE = process.env.API_BASE;

const {version: APP_VERSION} = require("../package.json");

const _current_requests = {};

let connection = {
  getBase: function () {
    return BASE;
  },

  getFullUrl: function (url, params) {
    return BASE + url + (params ? "?" + $.param(params) : "");
  },

  getVersion: function () {
    return APP_VERSION;
  },

  post: function (url, params, success, error, options) {
    if (!options)
      options = {};
    return new Promise((resolve, reject) => {
      if (_current_requests[url]) {
        _current_requests[url].counter++;
        if (Date.now() - _current_requests[url].at > 400 && Date.now() - (_current_requests[url].warned || 0) > 1000) {
          general.warning("O pedido está a ser processado...", "Aguarde");
          _current_requests[url].warned = Date.now();
        }
        return;
      }
      _current_requests[url] = {counter: 1, at: Date.now()};
      _axios.post(BASE + url, params, {
        withCredentials: true,
      }).then(res => {
        if (res.headers['content-type'] === "application/json" && typeof res.data === "string") {
          general.error("Invalid response", "label-error");
          return;
        }
        if (res.data.message && !(options && options.disableNotif)) {
          if (res.data.result === "success") {
            general.success(res.data.message);
          } else if (res.data.result === "warning") {
            general.warning(res.data.message);
          }
        }
        if (res.data.data) {
          success && success(res.data.data);
          resolve(res.data.data);
        } else {
          success && success(res.data);
          resolve(res.data);
        }
      }).catch(err => {
        if (err.response) {
          if (err.response.headers['content-type'] === "application/json" && typeof err.response.data === "string") {
            general.error("Invalid response", "label-error");
            return;
          }
          if (err.response.data.message && !(options && options.disableNotif)) {
            if (typeof err.response.data.message === 'string')
              err.response.data.message = [err.response.data.message];
            err.response.data.message.forEach(function (message, idx) {
              setTimeout(() => general.error(message), idx * 100);
            });
          }
          if (error)
            error(err.response.data, err.response.status);

          if (err.response.status === 401) {
            window.App.logout();
          }

          if (err.response.data.result === 'redirect') {
            window.location = err.response.data.location;
          }

          if (options.returnError)
            reject(err.response.data, err.response.status);
        }
      }).then(() => {
        delete _current_requests[url];
      });
    });
  },

  get: function (url, params, success, error, options) {
    checkAppVersion();
    if (!options)
      options = {};
    return new Promise((resolve, reject) => {
      url = BASE + url;
      _axios.get(url, {withCredentials: true, params: params})
        .then(res => {
          if (res.headers['content-type'] === "application/json" && typeof res.data === "string") {
            general.error("Invalid response", "label-error");
            return;
          }
          if (res.data.message && !(options && options.disableNotif))
            if (res.data.result === "success") {
              general.success(res.data.message);
            } else if (res.data.result === "warning") {
              general.warning(res.data.message);
            }

          if (res.data.data) {
            success && success(res.data.data);
            resolve(res.data.data);
          } else {
            success && success(res.data);
            resolve(res.data);
          }
        }).catch(err => {
        if (err.response) {
          if (err.response.headers['content-type'] === "application/json" && typeof err.response.data === "string") {
            general.error("Invalid response", "label-error");
            return;
          }
          if (err.response.data.message && !(options && options.disableNotif)) {
            if (typeof err.response.data.message === 'string')
              err.response.data.message = [err.response.data.message];
            err.response.data.message.forEach(function (message, idx) {
              setTimeout(() => general.error(message), idx * 100);
            });
          }
          if (error) {
            error(err.response.data, err.response.status);
          }

          if (err.response.data.result === 'redirect') {
            window.location = err.response.data.location;
          }

          if (err.response.status === 401) {
            window.App.logout();
          } else if (err.response.status === 403) {
            window.App.hist.replace("/");
          }

          if (options.returnError)
            reject(err.response.data, err.response.status);
        }
      });
    });
  },

  confirmUpdate: function () {
    general.alert("Está disponível uma nova versão do SFAE. Por favor clique em atualizar.", "Atualização", "Atualizar", () => {
      if (caches) {
        caches.keys().then(function (names) {
          for (let name of names) caches.delete(name);
        });
      }
      window.location.reload(true);
    });
  }

};

let nextVersionCheck = 0;

function checkAppVersion() {
  if (process.env.NODE_ENV === 'development')
    return;
  if (nextVersionCheck < +new Date()) {
    fetch('/meta.json', {
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
      .then((response) => response.json())
      .then((meta) => {
        const latestVersion = meta.version;
        if (!latestVersion)
          return;
        console.log("Local version: " + APP_VERSION, ", Latest Version: " + latestVersion);
        const shouldForceRefresh = semverGreaterThan(latestVersion, APP_VERSION);
        if (shouldForceRefresh) {
          connection.confirmUpdate();
        }
        // Wait 10 minutes before checking again
        nextVersionCheck = 1000 * 60 * 10 + (+new Date());
      });
  }
}

function semverGreaterThan(versionA, versionB) {
  const versionsA = versionA.split(/\./g);
  const versionsB = versionB.split(/\./g);

  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());
    const b = Number(versionsB.shift());
    // eslint-disable-next-line no-continue
    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
}

export default connection;
